<template>
  <div class="checkbox-item" @click="select(item)" :class="{selected: active == item.id}">
    <el-row type="flex">
      <el-col :span="20">
        <slot></slot>
      </el-col>
      <el-col :span="4" class="text-right">
        <i class="ico ico-check"></i>
      </el-col>
    </el-row>
  </div>
</template>

<script>

export default {
  name: 'CheckboxItem',
  props: ['active', 'item'],
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
    select (item) {
      this.$emit('changeItem', {
        item: item
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.checkbox-item {
  cursor: pointer;
  border-bottom: 1px solid #CDCDCD;
  padding-right: 25px;

  .ico-check {
    display: none;
  }

  &.selected {
    background-color: #F9F9FA;

    .ico-check {
      display: inline-block;
    }
  }
}
.el-row--flex {
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/CheckboxItem.vue